import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["alignTitle", "backgroundColorToken", "backgroundColorTokenArgs", "hasIcon", "height", "iconBackgroundColorToken", "iconBackgroundColorTokenArgs", "id", "innerHeight", "klarnaLogo", "klarnaLogoAccessibilityLabel", "klarnaLogoColorToken", "klarnaLogoColorTokenArgs", "leftAction", "leftIcon", "leftIconAriaLabel", "onLeftClick", "onRightClick", "rightAction", "rightIcon", "rightIconAriaLabel", "roundedCorners", "shouldTruncateTitle", "subtitle", "testID", "textColorToken", "textColorTokenArgs", "title", "UNSAFE_containerProps"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import KlarnaLogoFull from '@bubble-ui/asset-klarna-logo-full';
import Text from '@bubble-ui/primitive-text';
import View from '@bubble-ui/primitive-view';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import usePropDeprecationWarning from '@bubble-ui/hook-use-prop-deprecation-warning';
import { DesignContextForwardProvider, useDesignContext } from '@klarna/designtokens';
import TouchableIcon from '@bubble-ui/molecule-touchable-icon';
import { isNative } from '@bubble-ui/util-platform';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
import Action from './ActionBase';
import { defaultDesignTokens } from './defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getIds } from './getIds';
import { getKlarnaLogoFullProps } from './getKlarnaLogoFullProps';
var NavBar = _ref => {
  var {
      alignTitle,
      backgroundColorToken,
      backgroundColorTokenArgs,
      hasIcon,
      height,
      iconBackgroundColorToken,
      iconBackgroundColorTokenArgs,
      id,
      innerHeight,
      klarnaLogo,
      klarnaLogoAccessibilityLabel,
      klarnaLogoColorToken,
      klarnaLogoColorTokenArgs,
      leftAction,
      leftIcon,
      leftIconAriaLabel,
      onLeftClick,
      onRightClick,
      rightAction,
      rightIcon,
      rightIconAriaLabel,
      roundedCorners,
      shouldTruncateTitle,
      subtitle,
      testID,
      textColorToken,
      textColorTokenArgs,
      title,
      UNSAFE_containerProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropDeprecationWarning({
    componentName: 'NavBar',
    propName: 'innerHeight',
    shouldWarn: innerHeight !== undefined,
    removalDate: 'v6.0.0'
  });
  usePropDeprecationWarning({
    componentName: 'NavBar',
    propName: 'roundedCorners',
    shouldWarn: roundedCorners !== undefined,
    removalDate: 'v6.0.0'
  });
  usePropsSpreadingDeprecationWarning({
    componentName: 'NavBar',
    props,
    useInstead: 'UNSAFE_containerProps',
    removalDate: 'v7.0.0'
  });
  var designContext = useDesignContext(defaultDesignTokens);
  var designVersion = useDesignVersion();
  var ids = getIds(id);
  var {
    rootStyle,
    leftWrapperStyle,
    rightWrapperStyle,
    textWrapperStyle,
    textInnerWrapperStyle,
    titleStyle,
    titleSecondaryStyle,
    subtitleStyle,
    klarnaLogoStyle,
    leftActionStyle,
    leftIconStyle,
    rightActionStyle,
    rightIconStyle,
    paragraphSecondaryStyle
    // ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
    // Keep passing all props to the style sheet, even if we don't use them ourselves
  } = useStyleSheet(NavBar, getDefaultStyleSheet, _objectSpread(_objectSpread({}, props), {}, {
    alignTitle,
    backgroundColorToken,
    backgroundColorTokenArgs,
    designContext,
    designVersion,
    hasIcon,
    height,
    iconBackgroundColorToken,
    iconBackgroundColorTokenArgs,
    id,
    ids,
    innerHeight,
    klarnaLogo,
    klarnaLogoAccessibilityLabel,
    klarnaLogoColorToken,
    klarnaLogoColorTokenArgs,
    leftAction,
    leftIcon,
    onLeftClick,
    onRightClick,
    rightAction,
    rightIcon,
    leftIconAriaLabel,
    rightIconAriaLabel,
    roundedCorners,
    shouldTruncateTitle,
    subtitle,
    testID,
    textColorToken,
    textColorTokenArgs,
    title
  }));
  return /*#__PURE__*/React.createElement(View, _extends({
    id: ids === null || ids === void 0 ? void 0 : ids.root,
    testID: testID
  }, UNSAFE_containerProps, {
    style: rootStyle
  }, props), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.leftEdge,
    style: leftWrapperStyle
  }, leftAction && /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.leftActionWrapper,
    style: leftActionStyle
  }, /*#__PURE__*/React.createElement(Action, {
    id: ids === null || ids === void 0 ? void 0 : ids.leftAction,
    action: leftAction,
    colorToken: textColorToken,
    colorTokenArgs: textColorTokenArgs,
    onClick: onLeftClick,
    onPress: onLeftClick
  })), leftIcon && /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.leftIconWrapper,
    style: leftIconStyle
  }, /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
    context: designContext
  }, /*#__PURE__*/React.createElement(TouchableIcon, {
    id: ids === null || ids === void 0 ? void 0 : ids.leftIcon,
    Icon: leftIcon,
    colorToken: textColorToken ? textColorToken : 'navbar/icon-color',
    colorTokenArgs: textColorToken ? textColorTokenArgs : {},
    onClick: onLeftClick,
    onPress: onLeftClick,
    ariaLabel: leftIconAriaLabel
  })))), title && /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.textWrapper,
    style: textWrapperStyle
  }, /*#__PURE__*/React.createElement(View, {
    style: textInnerWrapperStyle
  }, /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.title,
    style: titleStyle
  }, /*#__PURE__*/React.createElement(Text, _extends({}, isNative ? {
    numberOfLines: shouldTruncateTitle ? 1 : 0
  } : {}, {
    tag: "h2",
    style: titleSecondaryStyle,
    id: ids === null || ids === void 0 ? void 0 : ids.paragraph
  }), title)), subtitle && /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.subtitle,
    style: subtitleStyle
  }, /*#__PURE__*/React.createElement(Text, _extends({}, isNative ? {
    numberOfLines: 0
  } : {}, {
    tag: "paragraph",
    style: paragraphSecondaryStyle
  }), subtitle)))), klarnaLogo && /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.klarnaLogo,
    style: klarnaLogoStyle
  }, klarnaLogo && /*#__PURE__*/React.createElement(KlarnaLogoFull, _extends({}, getKlarnaLogoFullProps({
    designContext,
    klarnaLogoColorToken,
    klarnaLogoColorTokenArgs
  }), {
    accessibilityLabel: klarnaLogoAccessibilityLabel
  }))), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.rightEdge,
    style: rightWrapperStyle
  }, rightAction && /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.rightActionWrapper,
    style: rightActionStyle
  }, /*#__PURE__*/React.createElement(Action, {
    id: ids === null || ids === void 0 ? void 0 : ids.rightAction,
    action: rightAction,
    colorToken: textColorToken,
    colorTokenArgs: textColorTokenArgs,
    onClick: onRightClick,
    onPress: onRightClick
  })), rightIcon && /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.rightIconWrapper,
    style: rightIconStyle
  }, /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
    context: designContext
  }, /*#__PURE__*/React.createElement(TouchableIcon, {
    id: ids === null || ids === void 0 ? void 0 : ids.rightIcon,
    Icon: rightIcon,
    colorToken: textColorToken ? textColorToken : 'navbar/icon-color',
    colorTokenArgs: textColorToken ? textColorTokenArgs : {},
    onClick: onRightClick,
    onPress: onRightClick,
    ariaLabel: rightIconAriaLabel
  })))));
};
NavBar.displayName = 'NavBar';
export default withProvisionalOverrideFromContext(NavBar);
//# sourceMappingURL=index.js.map